"use client";

import React from "react";
import {
  ResizablePanelGroup,
  ResizablePanel,
  ResizableHandle,
} from "@/shadcn-components/ui/resizable";
import { QuotesScreen } from "@/components/quotes-view";
import DesktopChartArea from "./DesktopChartArea";
import { useFixedPixelPanel } from "../hooks/useFixedPixelPanel";
import { DESKTOP_LAYOUT_STORAGE_KEYS } from "@/lib/localStorageKeys/desktop-layout";
import { useDesktopLayoutStore } from "@/lib/desktop-layout/store";
import { cn } from "@/lib/utils";

const QUOTES_SIDEBAR_DEFAULT_PX = 320;
const QUOTES_SIDEBAR_MIN_PX = 220;
const CHART_MIN_PERCENT = 40;

export default function ViewDesktop() {
  const quotesVisible = useDesktopLayoutStore((s) => s.quotesVisible);

  const {
    containerRef,
    groupRef,
    initialPercent,
    controlledMinPercent,
    handleLayout,
    handleDragging,
  } = useFixedPixelPanel({
    storageKey: DESKTOP_LAYOUT_STORAGE_KEYS.QUOTES_SIDEBAR_WIDTH_PX,
    defaultPx: QUOTES_SIDEBAR_DEFAULT_PX,
    minPx: QUOTES_SIDEBAR_MIN_PX,
    direction: "horizontal",
    controlledIndex: 0,
    otherMinPercent: CHART_MIN_PERCENT,
    isCollapsed: !quotesVisible,
  });

  return (
    <div ref={containerRef} className="flex h-full min-h-0 w-full flex-1 flex-col">
      <ResizablePanelGroup
        ref={groupRef}
        direction="horizontal"
        className="h-full min-h-0 flex-1"
        onLayout={handleLayout}
      >
        <ResizablePanel
          className="min-h-0 min-w-0"
          defaultSize={initialPercent}
          minSize={controlledMinPercent}
        >
          {quotesVisible ? <QuotesScreen isDesktop={true} /> : null}
        </ResizablePanel>

        <ResizableHandle
          onDragging={handleDragging}
          className={cn(!quotesVisible && "hidden")}
        />

        <ResizablePanel
          className="flex min-h-0 min-w-0 flex-col overflow-hidden"
          defaultSize={100 - initialPercent}
          minSize={CHART_MIN_PERCENT}
        >
          <DesktopChartArea />
        </ResizablePanel>
      </ResizablePanelGroup>
    </div>
  );
}
